import Svg from '@doordash/component-svg'
import { Colors } from '@doordash/design-language'
import * as React from 'react'
import { IconProps } from './'

// SVG converted using https://www.smooth-code.com/open-source/svgr/playground/

/* tslint:disable:max-line-length */
export const DocumentIcon: React.SFC<IconProps> = ({ size, color }) => (
  <Svg height={size} width={size} fill={color} viewBox="0 0 24 24 ">
    <title>{'background-check-document-icon'}</title>
    <g
      transform="translate(1 1)"
      stroke="#7E7C7C"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={Colors.SystemWhite}
      fillRule="evenodd"
    >
      <rect width={18} height={20} rx={0.801} />
      <path d="M3.6 8.6h10.8M6.6 3.6h4.8M3.5 12.6h10.8M3.5 15.6h10.8" />
    </g>
  </Svg>
)
/* tslint:enable:max-line-length */

export default DocumentIcon
